import component from './TilesConstructor.vue'
export default component
